import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-delete-users",
  "use": "icon-delete-users-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-delete-users\">\n<path d=\"M5 6C5 5.44772 5.44772 5 6 5H18C18.5523 5 19 5.44772 19 6V7H5V6Z\" fill=\"#42526E\" />\n<path d=\"M9 5C9 4.44772 9.44772 4 10 4H14C14.5523 4 15 4.44772 15 5V5H9V5Z\" fill=\"#42526E\" />\n<path d=\"M7 9H17V18C17 18.5523 16.5523 19 16 19H8C7.44772 19 7 18.5523 7 18V9Z\" stroke=\"#42526E\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol